module.exports = __webpack_public_path__ + "static/media/Argos - Notifications - Purple.1dff5da6.svg";